import React from 'react';
import PropTypes from 'prop-types';
import './TextInput.css';

export const TextInput = ({ label, required, value, handleChange }) => {
  return (
    <div className='text-input'>
      <label>
        <b>{label}</b>
        {required ? <span className='label-required'>*</span> : null}
        <div>
          <input type='text' value={value} onChange={(e) => handleChange(e.target.value)} />
        </div>
      </label>
    </div>
  );
};

TextInput.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  required: PropTypes.bool,
  handleChange: PropTypes.func
};
